
import { Injectable } from '@angular/core';

import { Headers, RequestOptions, Response, URLSearchParams } from '@angular/http';

import * as globais from './../../globais';
import { Http } from '@angular/http';
import { BehaviorSubject } from 'rxjs';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class DaoService {

  constructor(private client:Http, public messageService: MessageService) {
    this.itens = new BehaviorSubject<{}>([]);
    this.local = new BehaviorSubject<{}>([]);
   }
  versao = '1.0.0';
  itens:any;
  local:any;

  submeter(dados:any,acao: string): Promise<any>{
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    if(dados==null){
      dados = {};
    }

    let osdados = JSON.stringify(dados);
    // console.log("Dados empacotados");
    // console.log(osdados);
    
   let corpo: any = {"acao":acao,"dados":JSON.stringify(dados)};
   console.log("ENVIADO PARA O SERVIDOR",corpo);
    return this.client.post(globais.servidorLocalPaulo ,corpo,options).toPromise().then(this.extrairDados)
    .catch(this.lidarComErro);
      
  }

  submeterEm(dados:any,acao: string,em: string): Promise<any>{
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    if(dados==null){
      dados = {};
    }

    let osdados = JSON.stringify(dados);
    // console.log("Dados empacotados");
    // console.log(osdados);
    
   let corpo: any = {"acao":acao,"dados":JSON.stringify(dados)};
   console.log("ENVIADO PARA O SERVIDOR",corpo);
    return this.client.post(em ,corpo,options).toPromise().then(this.extrairDados)
    .catch(this.lidarComErro);
      
  }

  submeterSite(dados:any,acao: string): Promise<any>{
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    if(dados==null){
      dados = {};
    }

    
    
   let corpo: any = {"acao":acao,"dados":JSON.stringify(dados)};
  //  console.log("ENVIADO PARA O SERVIDOR",corpo);
    return this.client.post(globais.servidorCensoSite ,corpo,options).toPromise().then(this.extrairDados)
    .catch(this.lidarComErro);
      
  }

  ordenar(lista,campo=null){ // ordena json pelo nome do campo
    let res = [];
    if(!campo){
      lista.sort((a,b)=>{
        return (a+'').trim().toLowerCase()>(b+'').trim().toLowerCase() ? 1: (a+'').trim().toLowerCase()<(b+'').trim().toLowerCase() ?-1:0;
      });
    }else{
      lista.sort((a,b)=>{
        return (a[campo]+'').trim().toLowerCase()>(b[campo]+'').trim().toLowerCase() ? 1: (a[campo]+'').trim().toLowerCase()<(b[campo]+'').trim().toLowerCase() ?-1:0;
      });
    }
    
    res = lista;
    return res;
  }

  toast(cor, texto) { 
    
    if(cor=='s')cor = 'success';
    if(cor=='e')cor = 'error';
    if(cor=='i')cor = 'info';

    if(cor=='info'){
      
      texto = "<table><td><i class=\"fa fa-info-circle fa-3x\"></i></td><td>"+texto+"</td></table>";
    }

    if(cor=='success'){
      
      texto = "<table><td><i class=\"fa fa-smile-o fa-3x\"></i></td><td>"+texto+"</td></table>";
    }

    if(cor=='error'){
      texto = "<table><td><i class=\"fa fa-frown-o fa-3x\"></i></td><td>"+texto+"</td></table>";
      
    }
    
    this.messageService.add({key: 'main', severity: cor, summary: '', detail: texto });
  }

  validarCPF(strCPF:any) {
    let Soma;
    let Resto;
    Soma = 0;
    if (strCPF == "00000000000") return false;

  for (let i=1; i<=9; i++) Soma = Soma + parseInt(strCPF.substring(i-1, i)) * (11 - i);
  Resto = (Soma * 10) % 11;

    if ((Resto == 10) || (Resto == 11))  Resto = 0;
    if (Resto != parseInt(strCPF.substring(9, 10)) ) return false;

  Soma = 0;
    for (let i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i-1, i)) * (12 - i);
    Resto = (Soma * 10) % 11;

    if ((Resto == 10) || (Resto == 11))  Resto = 0;
    if (Resto != parseInt(strCPF.substring(10, 11) ) ) return false;
    return true;
}

  extrairDados(res: Response){ 
    // console.log("Resposta HTTP");
    // console.log(res);  
    let body = res.json();
        return body || {};
  }

  getEnderecoCep(cep): Promise<any> {
    return this.client.get("http://viacep.com.br/ws/" + cep + "/json/").toPromise().then(this.extrairDados)
    .catch(this.lidarComErro);   
  }

  getJSON(json){
    return this.client.get("./assets/json/" + json).toPromise().then(this.extrairDados)
    .catch(this.lidarComErro);   
 }  

  retornarTeste(){
    return "positivo";
  }

  lidarComErro(error: any): Promise<any>{
    console.error('An error occurred', error);
    return Promise.reject(error.message || error);
  }


  //montagem de Menus

  menuGeral = [];

  montarHome(){
    let menuAgenda: any = {}; // declaro o menu da agenda
    
      menuAgenda = {// instancio o menu caso positivo
        label: 'Home', icon: 'pi pi-fw pi-home', "routerLink": '/principal'
           }

    this.menuGeral.push(menuAgenda);
  }

  montarMenuAgenda(){
    let permissoes = (JSON.parse(localStorage.getItem("usuario_logado_rtm")).permissoes);
    if(permissoes==null || permissoes==undefined)permissoes = '';
    let menuAgenda: any = {}; // declaro o menu da agenda
    if(permissoes.includes('vag')){ // checo se usuario tem permissao
      menuAgenda = {// instancio o menu caso positivo
        label: 'Agenda', icon: 'fa fa-calendar',items: [
          {label:'Visão Geral','routerLink':'/agenda', icon: "fa fa-globe"}
        ]};
    }

    this.menuGeral.push(menuAgenda);

  }

  montarCadastros(){
    let permissoes = (JSON.parse(localStorage.getItem("usuario_logado_rtm")).permissoes);
    if(permissoes==null || permissoes==undefined)permissoes = '';
    let menuAgenda: any = {}; // declaro o menu da agenda
    // checo se usuario tem permissao
      menuAgenda = {// instancio o menu caso positivo
        label: 'Cadastros',
        icon: 'pi pi-fw pi-pencil',items: [// tentar colocar os itens como permissão de acesso
          {label: 'Colaborador', icon: 'fa fa-users', "routerLink": '/colaborador'}
        ]};       
        if(permissoes.includes('acessarOrgao')){
          let temp = Object();
          temp.label = "Ente";
          temp.icon = "fa fa-building-o";
          temp.routerLink = "/orgao";
          menuAgenda.items.push(temp);
        }          
    

    this.menuGeral.push(menuAgenda);

  }


 


  montarAdministrativo(){
    let permissoes = (JSON.parse(localStorage.getItem("usuario_logado_rtm")).permissoes);
    if(permissoes==null || permissoes==undefined)permissoes = '';
    let menuAgenda: any = {}; // declaro o menu da agenda
    if(permissoes.includes('adm')){ // checo se usuario tem permissao
      menuAgenda = {// instancio o menu caso positivo
        label: 'Administrativo',
        icon: 'fa fa-clipboard',items: []       
        };
        if(permissoes.includes('acessarContrato')){
          let temp = Object();
          temp.label = "Contrato";
          temp.icon = "fa fa-file-o";
          temp.routerLink = "/contrato";
          menuAgenda.items.push(temp);          
        }
        if(permissoes.includes('acessarFornecedor')){
          let temp = Object();
          temp.label = "Fornecedor";
          temp.icon = "fa fa-truck";
          temp.routerLink = "/fornecedor";
          menuAgenda.items.push(temp);          
        }
        if(permissoes.includes('acessarParceiro')){
          let temp = Object();
          temp.label = "Parceiro";
          temp.icon = "fa fa-handshake-o";
          temp.routerLink = "/parceiro";
          menuAgenda.items.push(temp);          
        }
        if(permissoes.includes('acessarAgendaTelefonica')){
          let temp = Object();
          temp.label = "Agenda Telefônica";
          temp.icon = "fa fa-phone";
          temp.routerLink = "/agendaTelefonica";
          menuAgenda.items.push(temp);          
        }
        /* if(permissoes.includes('acessarLicitacoes')){
          let temp = Object();
          temp.label = "Licitações";
          temp.icon = "fa fa-gavel";
          temp.routerLink = "/licitacoes";
          menuAgenda.items.push(temp);          
        } */
    }

    this.menuGeral.push(menuAgenda);

  }

  montarMenuFinanceiro(){
    let permissoes = (JSON.parse(localStorage.getItem("usuario_logado_rtm")).permissoes);
    if(permissoes==null || permissoes==undefined)permissoes = '';
    let menuFinanceiro: any = {}; // declaro o menu da agenda
    
    if(permissoes.includes('finMenu')){ // checo se usuario tem permissao
      menuFinanceiro = {// instancio o menu caso positivo
        label: 'Financeiro', icon: 'fa fa-money',items: [
          
        ]};

        if(permissoes.includes('finCal')){
          menuFinanceiro.items.push({label:'Calendário RxD','routerLink':'/calendario', icon: "fa fa-calendar-o"});
        }
        if(permissoes.includes('finCategoria')){
          menuFinanceiro.items.push({label:'Categoria(s)','routerLink':'/categoria', icon: "fa fa-list-ol"});
        }
        if(permissoes.includes('finDespesasReceitas')){
          menuFinanceiro.items.push({label:'Despesas x Receitas','routerLink':'/despesaReceita', icon: "fa fa-list-ol"});
        }

        if(permissoes.includes('acEquip')){
          menuFinanceiro.items.push({label:'Equipamentos','routerLink':'/equipamentos', icon: "fa fa-suitcase"});
        }

        if(permissoes.includes('acMateriais')){
          menuFinanceiro.items.push({label:'Materiais','routerLink':'/materiais', icon: "fa fa-tags"});
        }

        if(permissoes.includes('acViagens')){
          menuFinanceiro.items.push({label:'R. Viagens','routerLink':'/viagens', icon: "fa fa-globe"});
        }

    }

    this.menuGeral.push(menuFinanceiro);

  }

  montarMenuAtuarial(){
    let permissoes = (JSON.parse(localStorage.getItem("usuario_logado_rtm")).permissoes);
    if(permissoes==null || permissoes==undefined)permissoes = '';
    let menuAtuarial: any = {}; // declaro o menu da agenda
    
    if(permissoes.includes('atuaMenu')){ // checo se usuario tem permissao
      menuAtuarial = {// instancio o menu caso positivo
        label: 'Atuarial', icon: 'fa fa-adn',items: [
          
        ]};

        if(permissoes.includes('atuaClientes')){
          menuAtuarial.items.push({label:'Clientes','routerLink':'/clientes', icon: "fa fa-child"});
        }

        if(permissoes.includes('atuaTecnico')){
          menuAtuarial.items.push({label:'Nível Técnico','routerLink':'/nivel-tecnico', icon: "fa fa-slack"});
        }

    }

    this.menuGeral.push(menuAtuarial);

  }

  retornarNomeMes(mes){
    if(mes == 0){
      return "Janeiro";
    }else if(mes == 1){
      return "Fevereiro";
    }else if(mes == 2){
      return "Março";
    }else if(mes == 3){
      return "Abril";
    }else if(mes == 4){
      return "Maio";
    }else if(mes == 5){
      return "Junho";
    }else if(mes == 6){
      return "Julho";
    }else if(mes == 7){
      return "Agosto";
    }else if(mes == 8){
      return "Setembro";
    }else if(mes == 9){
      return "Outubro";
    }else if(mes == 10){
      return "Novembro";
    }else if(mes == 11){
      return "Dezembro";
    }
  }
  
  mudarLocal(novoLocal){
    this.local.next(novoLocal);
    }

  formarMenu(){
    let valor = localStorage.getItem("usuario_logado_rtm");
    console.log(valor);
    if(valor!=undefined){
      this.menuGeral = []; // zero o menu
    

      this.montarHome(); // tenta Montar a HOME
      this.montarMenuAgenda(); // tenta Montar a Agenda
      this.montarCadastros(); // Tenta Montar o Cadastro -- tentar especializar por seção
      this.montarAdministrativo();
      this.montarMenuFinanceiro();
      this.montarMenuAtuarial();
       
  
      this.itens.next(this.menuGeral);
    }

    
    
    

  }
}
